export const RequestHeader = Object.freeze({
  UserAgentQS: '$User-Agent-QS',
  DeviceInfoQS: '$Device-Info-QS',
})
